import React from 'react';
import {Box, Button, Paper, Typography} from '@mui/material';
import {router} from 'app/router/main';
import {StyleSx, Sx} from 'app/types/common';
import {packSx} from 'app/util/packSx/packSx';
import {Main} from 'app/components/entities/cloud';
import {FilesWelcome} from 'app/components/features/files';
import {UnitFiles} from 'app/components/widgets/files';

interface Props extends Sx {
  teamId: string;
  deviceId: string;
  online: boolean;
  permitSubscribe: boolean;
  capability: Main.CapabilityState;
}

export function UnitFileManagement({
  sx,
  teamId,
  deviceId,
  online,
  capability,
  permitSubscribe,
}: Props) {
  if (!capability.enabled) {
    if (capability.reason === 'subscription_is_dq') {
      return <LockNotice sx={sx} paymentAccess={permitSubscribe} />;
    }

    return <FilesWelcome sx={sx} permitEdit={permitSubscribe} />;
  }

  return (
    <UnitFiles sx={packSx({flex: 1}, sx)} teamId={teamId} deviceId={deviceId} online={online} />
  );
}

const noticeSx: StyleSx = {
  p: 3,
  display: 'flex',
  direction: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderColor: 'error.main',
};

interface LockProps extends Sx {
  paymentAccess: boolean;
}

function LockNotice({sx, paymentAccess}: LockProps) {
  return (
    <Paper sx={packSx(noticeSx, sx)} variant="outlined">
      <Box>
        <Typography variant="h5" fontWeight={600} mb={2}>
          Epiphan Edge File Management disabled
        </Typography>

        <Typography color="text.secondary">
          The File Management page is currently disabled due to an unsuccessful payment.{' '}
          {paymentAccess
            ? 'Please update your payment method to restore access.'
            : 'Please contact your Epiphan cloud team owner to update billing information in order regain access.'}
        </Typography>
      </Box>

      {paymentAccess && (
        <Button variant="contained" color="secondary" href={router.url('settingBillingUsage')}>
          Update payment
        </Button>
      )}
    </Paper>
  );
}
